import { Component, OnInit } from '@angular/core';
import { ConfigService } from 'app/services/config/config.service';
import { SharedModule } from 'app/shared.module';
import { environment } from 'environments/environment';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: true,
    imports: [SharedModule]
})
export class FooterComponent implements OnInit {
    now : Date = new Date();
    env = environment;

    
    constructor(public configService: ConfigService) { }

    ngOnInit() {}


    getUrlBase(){
        return environment.urlBase;
    }
}
